import { Callout, IconCalendarEuroRegular, ButtonLink, skinVars, Text1 } from '@telefonica/mistica';
import { AxiosResponse } from 'axios';
import './index.scss';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ISharedProps } from '../../models/interfaces';
import { getDevices } from '../../services/ProductService';
import { getFormatDate } from '../../utils/dataTransformation/dateConversions';
import MobileSections from '../MobileSections';
import OtherServicesSection from '../OtherServicesSection';
import { CardsHome } from '../CardsFlexHome';
import { WarningLine } from '../WarningEsim';
import { Device } from '../../models/Devices';
import { useMobileLinesContext } from '../../context/mobile-lines-context/MobileLinesContext';
import { useConfigureLineContext } from '../../context/configure-line-context/ConfigureLineContext';
import { InfoSIM } from '../../models/ConfigureLine';
import useSimsInfos from '../../hooks/useSimsInfos';
import useChangeOwnership from '../../hooks/useChangeOwnership';
import { useChangeOwnershipContext } from '../../context/change-ownership-context/ChangeOwnershipContext';

const Convergent: React.FC<ISharedProps> = (dataTab: any) => {
    const { t } = useTranslation();
    const { setOptionShowDataSharing } = useMobileLinesContext();
    const { setIsConvergent } = useConfigureLineContext();
    const [billing] = useState(dataTab.dataTab.cycleEnded);
    const [devices, setDevices] = useState<Device[]>([]);
    const [dataSims, setDataSims] = useState<InfoSIM[]>([]);
    const { simsInfosRequest } = useSimsInfos();
    const { getChangeOwnership } = useChangeOwnership();
    const { dataChangeOwnership } = useChangeOwnershipContext();

    useEffect(() => {
        simsInfosRequest(setDataSims);
        getChangeOwnership();
    }, []);

    useEffect(() => {
        setOptionShowDataSharing(dataTab.dataTab?.additionalMobiles?.length > 0);
    }, []);

    useEffect(() => {
        setIsConvergent(true);
    }, []);

    useEffect(() => {
        getDevices().then((response: AxiosResponse) => {
            setDevices(response.data);
        });
    }, []);

    return (
        <div className='convergent-page'>
            <div className='convergent-page__content'>
                <WarningLine warningsInfo={dataSims!} changeOfOwnership={dataChangeOwnership} />
                {billing && (
                    <div className='convergent-page__content-callout'>
                        <Callout
                            asset={<IconCalendarEuroRegular />}
                            title={t('consumptionInformation')}
                            description={t('consumptionInformationDescription')}
                            buttonLink={
                                <ButtonLink
                                    onPress={() => {
                                        alert({
                                            title: t('consumptionInformation'),
                                            message: t('alertCycleEndedDescription'),
                                            acceptText: t('buttonUnderstoodFeedback'),
                                            icon: (
                                                <IconCalendarEuroRegular
                                                    size={64}
                                                    color={skinVars.colors.brand}
                                                ></IconCalendarEuroRegular>
                                            ),
                                        });
                                    }}
                                >
                                    {t('moreInformation')}
                                </ButtonLink>
                            }
                        />
                    </div>
                )}
                <div className='convergent-page__content-mobileSections'>
                    <MobileSections dataMobiles={dataTab} sharedData={dataTab.sharedData}></MobileSections>
                </div>
                <div className='convergent-page__content-otherServicesSection-title'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('otherServices')}
                    </Text1>
                </div>
                <div className='convergent-page__content-otherServices-cards'>
                    <OtherServicesSection
                        dataTab={dataTab.dataTab.fiber}
                        BillingCycle={`${getFormatDate(dataTab.dataTab.cycleStarts, 'DD/MM')} - ${getFormatDate(
                            dataTab.dataTab.cycleEnds,
                            'DD/MM',
                        )} `}
                        closing={`${dataTab.dataTab.cycleEndInDays} ` + t('day')}
                        devices={devices}
                        ott={dataTab.dataTab.ott}
                    ></OtherServicesSection>
                </div>
                <CardsHome product='convergent'></CardsHome>
            </div>
        </div>
    );
};

export default Convergent;
